import useZWR from "@/utils/use-zwr";
import useFetcher from "@/utils/use-fetcher";
import useYWR, { YWRKey } from "@/features/ui/hooks/use-ywr";

export interface GetVerificationCodeRequest {
  mobileNumber: string;
}

interface GetVerificationCodeResponse {
  message: string;
}

interface GetVerificationCodePathParameter {}

export const getVerificationCodeTemplateUrl = `/verification/sms`;
export const getVerificationCodeKey: YWRKey<GetVerificationCodePathParameter> =
  {
    url: getVerificationCodeTemplateUrl,
    method: "post",
  };
export default function useGetVerificationCode() {
  const fetcher = useFetcher<
    GetVerificationCodeRequest,
    GetVerificationCodeResponse
  >();
  return useYWR(getVerificationCodeKey, fetcher);
}
